<section class="auth-page">
  <div class="auth-card">
    <img class="auth-logo" src="assets/logo.png" alt="Capital Hub">
    <p class="eyebrow mb-1">Account Recovery</p>
    <h1>Reset password</h1>
    <p class="text-muted-soft">Enter your admin email address and we will send reset instructions.</p>

    <form class="mt-4" (ngSubmit)="submit()">
      <label class="form-label">Email address</label>
      <input class="form-control" type="email" name="email" [(ngModel)]="email" required>
      <button class="btn btn-accent w-100 mt-4" [disabled]="loading || !email">
        {{ loading ? 'Sending...' : 'Send reset link' }}
      </button>
      @if (message) {
        <div class="alert alert-info py-2 mt-3">{{ message }}</div>
      }
      <a routerLink="/login" class="small-link d-block text-center mt-3">Back to login</a>
    </form>
  </div>
</section>
